import React from "react";
import Routers, { RenderRoutes } from "./routes/routes";
import { BrowserRouter, HashRouter } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <RenderRoutes routers={Routers} />
    </BrowserRouter>
  );
}

export default App;
